var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.123,
    height: 10.982,
    viewBox: "0 0 14.123 10.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6168",
    "data-name": "Group 6168",
    transform: "translate(-286.949 -284.154)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_526",
    "data-name": "Ellipse 526",
    cx: 1.122,
    cy: 1.122,
    r: 1.122,
    transform: "translate(289.189 287.261)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7111",
    "data-name": "Path 7111",
    d: "M6.542,6H4.476A1.476,1.476,0,0,0,3,7.476V9.542a1.476,1.476,0,0,0,.432,1.044l4.459,4.459a1.476,1.476,0,0,0,2.088,0l2.066-2.066a1.476,1.476,0,0,0,0-2.088L7.586,6.432A1.476,1.476,0,0,0,6.542,6Z",
    transform: "translate(284.449 279.158)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7112",
    "data-name": "Path 7112",
    d: "M16.412,14.935l2.066-2.066a1.476,1.476,0,0,0,0-2.088L13.29,5.593",
    transform: "translate(281.661 279.268)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.f6730dd3.svg";
export { ForwardRef as ReactComponent };